import HttpClient from "../services/HttpClient";
import { APP_URL, PROVINCES, TOWNSBYPROVINCE } from "../constants";

export const getProvinces = () => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${PROVINCES}`, headers)
      .then((response) => {
        if (response.data.result) {
          resolve(response);
        }
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getTownsByProvinceId = (id) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${TOWNSBYPROVINCE}${id}`, headers)
      .then((response) => {
        if (response.data) {
          resolve(response);
        }
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};
